import * as React from 'react';
import { useSelector } from 'react-redux';
import { debounce } from 'throttle-debounce';

import { useIsDesktop } from '../../components/Responsive/utils';
import { Hero as HeroMobile } from '../../components/Hero/views/mobile';
import { Hero as HeroDesktop } from '../../components/Hero/views/desktop';
import { getStripContent } from './utils';
import { isElementInViewport } from '../../utils/isElementInViewport';

import { trackStripSwipe } from './tracking';

export interface IStripBlock {
  htmlItem: HTMLElement;
  isViewed: boolean;
}

export function HeroContainer() {
  const stripRef = React.useRef<HTMLDivElement>(null);
  const stripContent = useSelector(getStripContent);
  const isDesktop = useIsDesktop();
  const [stripBlocks, setStripBlocks] = React.useState<IStripBlock[]>([]);

  React.useEffect(() => {
    const children = (stripRef.current && Array.from(stripRef.current.children)) || [];

    const preparedData = children.map((item: HTMLElement) => {
      return {
        htmlItem: item,
        isViewed: isElementInViewport(item, 1),
      };
    });

    setStripBlocks(preparedData);
  }, []);

  const onSwipe = React.useCallback(
    debounce(250, () => {
      const updatedStripBlocks = stripBlocks.map((stripBlock, index) => {
        if (!stripBlock.isViewed && isElementInViewport(stripBlock.htmlItem, 1)) {
          trackStripSwipe(`${index + 1}/${stripBlocks.length}`);

          return {
            ...stripBlock,
            isViewed: true,
          };
        }

        return stripBlock;
      });

      setStripBlocks(updatedStripBlocks);
    }),
    [stripBlocks],
  );

  return isDesktop ? (
    <HeroDesktop stripContent={stripContent} />
  ) : (
    <HeroMobile stripContent={stripContent} stripRef={stripRef} onSwipe={onSwipe} />
  );
}
